import {Model} from '@/models/Model'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'

export class Product extends Model {
  declare id: number
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  name2: string | null

  nickname: string | null

  detail: string | null
  code: string | null
  type: string | null
  erp_code2: string | null
  erp_barcode: string | null
  dimension_width: number | null
  dimension_height: number | null
  dimension_long: number | null
  volume: number | null
  weight: number | null
  viscous: number | null


  unit_single: string | null
  unit_primitive: string | null
  unit_prim_rate: number | null

  mode: string | null


  getResourceURL(): string {
    return Helper.setting.product.getResourceAPI
  }
}

export class DataProductsArray extends DataArray {

  declare data: Product[]
  filter: FilterProduct = new FilterProduct()
}


export class DataProduct extends DataResource {
  declare data: Product
}

export class FilterProduct {

  type: FilterSet = new FilterSet()
}
